import { DOCUMENT_KINDS, type DocumentKind } from '@glory/documents/domain';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import {
  type DocumentSettingsTab,
  DocumentSettingsPage,
} from '../../../features/documents/ui/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

const TABS: readonly DocumentSettingsTab[] = ['texts', 'numbering', 'history'];

interface DocumentSettingsSearch {
  readonly tab?: DocumentSettingsTab | undefined;
  readonly kind?: DocumentKind | undefined;
}

export const Route = createFileRoute('/_app/settings/documents')({
  validateSearch: (search: Record<string, unknown>): DocumentSettingsSearch => ({
    tab: TABS.find((tab) => tab === search.tab),
    kind: DOCUMENT_KINDS.find((kind) => kind === search.kind),
  }),
  // Тексты документов, оферту, нумерацию и сроки подписания правит только `documents.templates`.
  beforeLoad: requireSettingsPermission('documents.templates'),
  component: DocumentSettingsRoute,
});

function DocumentSettingsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <DocumentSettingsPage
      tab={search.tab ?? 'texts'}
      kind={search.kind ?? 'offer'}
      onNavigate={(patch) => {
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
      }}
    />
  );
}
